(function(){
    'use strict';

    angular
    .module('appback')
    .controller('CentrosController', CentrosController)
 
    CentrosController.$inject = ["CentroService","$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function CentrosController(CentroService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this;
        vm.getInfoCentro = function(centro_id){
        	CentroService.getInfoCentro(centro_id,function(data){

        		vm.infoCentro = data;
        		vm.ctXCompra = document.getElementById('myChartFactCentro');
        		vm.ctXCompra.height = 350;
        		vm.ctXCompra = vm.ctXCompra.getContext('2d');
				vm.chartAnual = new Chart(vm.ctXCompra, {
				    type: 'bar',
				    data: {
				        labels: data.facturas.fechas,
				        datasets: [{
				            label: 'Facturación',
				            data: data.facturas.importe,
				            borderWidth: 1
				        }]
				    },
				    options: {
				        scales: {
				            yAxes: [{
				                ticks: {
				                    beginAtZero: true
				                }
				            }]
				        }
				    }
				});
        	});

        }
        
    }
  
})();